import { AddressField, AddressFieldConfiguration } from '@marketplace-web/address/address-data'

import {
  EscrowRefundEstimateElementModel,
  settingsUserInputEvent,
} from '@marketplace-web/complaints/complaints-data'

export const findShippingOption = (options, code) => {
  if (!options) return undefined

  return options.find(option => option.code === code)
}

export const findRefundEstimateElement = (
  elements: Array<EscrowRefundEstimateElementModel> | undefined,
  type,
): EscrowRefundEstimateElementModel | undefined => {
  if (!elements) return undefined

  return elements.find(element => element.type === type)
}

export const scrollIntoViewById = (elementId: string): void => {
  const { document } = window

  const elementScrollTo = document.getElementById(elementId)

  if (!elementScrollTo) return

  elementScrollTo.scrollIntoView({ behavior: 'smooth', block: 'start' })
}

const addressFieldConfig: Array<AddressFieldConfiguration> = [
  {
    field: AddressField.Name,
    required: true,
  },
  {
    field: AddressField.Country,
  },
  {
    field: AddressField.Line1,
    required: true,
  },
  {
    field: AddressField.Line2,
  },
  {
    field: AddressField.PostalCode,
    required: true,
  },
  {
    field: AddressField.City,
    required: true,
  },
]

export const addressFieldConfiguration = addressFieldConfig.map(field => {
  return {
    field: field.field,
    required: field.required,
    trackingEvent: settingsUserInputEvent({
      screen: 'get_shipping_label',
      target: field.field,
      isValid: true,
    }),
  }
})

export default addressFieldConfiguration
